/**
 * Get the parent route from the current pathname
 * @param pathname - The current pathname (e.g., '/sales/summary/123')
 * @returns The parent route (e.g., '/sales')
 */
export const getParentRoute = (pathname: string): string => {
  const pathSegments = pathname.split('/').filter(Boolean);
  return pathSegments.length > 1 ? `/${pathSegments[0]}` : '/';
};

/**
 * Get the parent route from the current location
 * @param pathname - The current pathname
 * @param fallback - Fallback route if no parent can be determined
 * @returns The parent route or fallback
 */
export const getParentRouteWithFallback = (pathname: string, fallback: string = '/'): string => {
  const parentRoute = getParentRoute(pathname);
  return parentRoute === '/' ? fallback : parentRoute;
};
